
import { Button, Card, Collapse } from '@blueprintjs/core';
import React, { useState, ChangeEvent } from 'react';
import InputField from '../../../../components/shared/input-field';
import { FormDataT } from '../../../../utils/constants';
import { CustomButton, Box, CustomCard, CustomSelect, ItemType } from 'ui-components';
import { AddressT } from 'ui-io/company-io';

const Addresses = ({ addresses, changeFormData }: { addresses: AddressT[], changeFormData: (name: string, value: any) => void }) => {
	const [isAddressExpanded, setAddressExpanded] = useState(true);
	const AddressTypeOptions = [
  { label: "Registered", value: "REGISTERED" },
  { label: "Headquarter", value: "HEADQUATER" },
  { label: "Service", value: "SERVICE" },
  { label: "Business", value: "BUSINESS" },
  { label: "Corporate", value: "CORPORATE" },
  { label: "Branch", value: "BRANCH" },
  { label: "Operations", value: "OPERATIONS" },
  { label: "Manufacturing", value: "MANUFACTURING" },
  { label: "Research and Development", value: "RESEARCH_AND_DEVELOPMENT" },
  { label: "Distribution", value: "DISTRIBUTION" },
  { label: "Warehouse", value: "WAREHOUSE" },
  { label: "Administrative", value: "ADMINISTRATIVE" },
  { label: "Sales", value: "SALES" },
  { label: "Customer Support", value: "CUSTOMER_SUPPORT" },
  { label: "Technical Support", value: "TECHNICAL_SUPPORT" },
] as const;

	const addAddressRow = () => {
		const newRow: AddressT = { 
			full_address:'',
			street: '', 
			city: '', 
			state:'',
			country: '', 
			postal_code: '' ,
			type:'REGISTERED'
		};

		const updatedAddresses: AddressT[] = [
			...(Array.isArray(addresses) ? addresses : []),
			newRow,
		];
		changeFormData('companyDetail.addresses', updatedAddresses);
	};
	const removeAddressRow = (index: number) => {
		const updatedAddresses = addresses.filter((_: any, i: number) => i !== index);
		changeFormData('companyDetail.addresses', updatedAddresses);
	};
	const updateAddressRow = (index: number, field: keyof AddressT, value: string) => {
		const updatedAddresses = [...addresses];
		updatedAddresses[index] = { ...updatedAddresses[index], [field]: value };
		changeFormData('companyDetail.addresses', updatedAddresses);
	};
	return (
		<>
			<CustomButton
				className='mb-sm'
				onClick={() => setAddressExpanded(!isAddressExpanded)}
				icon={isAddressExpanded ? 'chevron-down' : 'chevron-right'}
			>
				Address
			</CustomButton>
			<Collapse isOpen={isAddressExpanded}>
				<Card className='mb-sm mt-none pt-sm pb-sm'>
					{Array.isArray(addresses) && addresses.map((address: AddressT, index: number) => (
						<CustomCard key={index}>
							{addresses.length > 1 && (
									<Box flex='true' justify='end' items='center' my={"small"}>
										<Button
											size='small'
											icon='trash'
											aria-label='delete'
											onClick={() => removeAddressRow(index)}
										/>
									</Box>
							)}
							<Box key={index} flexDir='col' justify='between' mb='small' pt={"0"} gap={"small"}> 
								{
									Object.keys(address).filter((field) => field !== 'type' && field !== 'full_address').map((field) => (
										<InputField
											key={`${field}${index}`}
											label={field.charAt(0).toUpperCase() + field.slice(1).replace('_', ' ')}
											name={`address[${index}].${field}`}
											type="text"
											value={address[field as keyof AddressT] || ""}
											onChange={(e: ChangeEvent<HTMLInputElement>) =>
												updateAddressRow(index, field as keyof AddressT, e.target.value)
											}
											mt="5px"
											mb="5px"
											ptb="5px"
											inputContainerClass={"mt-none"}
										/>

									))
								}
								<CustomSelect
								  label={AddressTypeOptions.find(e => e.value === addresses[index].type)?.label ?? ""}
									isActiveItem={true}
									items={AddressTypeOptions.map((f: any) => ({
										label: f.label,
										value: f.value,
									}))}
									values={["type"]}
									onSelect={(item: ItemType) => {
										updateAddressRow(index,"type",item.value);
									}}
									labelFontSize={"12px"}
									errorClassName={"min-h-25 mt-sm"}
									filterable={AddressTypeOptions.length > 15}
								/>
							</Box>
							<Box>
								
							</Box>
						</CustomCard>
					))}
					<CustomButton onClick={addAddressRow} icon="add" bradius="5px" className='mt-md mb-md'>
						Add
					</CustomButton>
				</Card>
			</Collapse>
		</>
	);
};

export default Addresses;

